export const overallResults = {
  NEGATIVE: 'negative',
  POSITIVE: 'positive'
};